export const Colors = {
  Border: '#eee',
  Primary: '#6DA7A7',
  Secondary: '#3C6060',
  Gray: '#999'
};
